<template>
  <div>
    <IntegrationsWizard />
  </div>
</template>

<script>
import IntegrationsWizard from '@/components/Integrations/IntegrationsWizard';

export default {
  name: 'Integrations',
  components: { IntegrationsWizard },
};
</script>

<style scoped>

</style>
